import React, {Component} from 'react'
import {connect} from 'react-redux'
import { actions } from 'react-redux-form';
import {Grid, Row, Col} from 'react-bootstrap'
import PageTitle from '../common/page-title'
import InlineCKEditor from '../common/editor/inline-editor'
import IndividualRewardsStatement from './individual-rewards-statement'
import {loadPageContent} from '../../actions/content';
import { initialStates } from '../../initialStates';
import { getOutletsForIndividualPointsStatement} from '../../actions/points-statement';

class PointsStatement extends Component {
  constructor(props) {
    super(props);
    this.pageSlug = 'points-statement';
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getOutletsForIndividualPointsStatement()).then(() => {
      dispatch(actions.load('deep.points_statement', initialStates.point_statement));
    });
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));

  }


  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container" className="points-statement">
        <Row>
          <Col lg={12}>
            <PageTitle>Points Statement</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
        <Row>
          <IndividualRewardsStatement/>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contents: state.content.list,
    profile: state.viewConfig.profile,
    stores:   state.points_statement.outlets,
  };
};


export default connect(mapStateToProps)(PointsStatement)



// WEBPACK FOOTER //
// ./src/components/points-statement/index.jsx